__turbopack_context__.v({
  "Inner": "ArticlesResults-module-scss-module__RkXIiG__Inner",
});
